import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespace } from '../../../translation/namespace';

import { Form, SonForm, useForm } from '../../../_lib/Form2';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { useModalContext } from '../../organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import UserInviteFormTemplate from './UserInviteFormTemplate';
import { useNavigate, useLocation } from 'react-router';

type TeamroomInviteType = {
  form: SonForm<any>;
  members?: {
    ids: string[];
  };
};

function TeamroomInvite({ form }: TeamroomInviteType) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { additionalProps } = useViewContext();
  const { translationNamespace } = additionalProps;

  const { closeModal } = useModalContext();
  const delayedModalClose = useDelayed(() => {
    closeModal();
    navigate(location.pathname);
  });

  const onSuccess = () => {
    delayedModalClose();
  };

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess,
  });

  return (
    <Form id="teamroom-invite-form" {...formProps}>
      <UserInviteFormTemplate
        params={params}
        fetchState={fetchState}
        headline={t(`${translationNamespace}:headline`)}
        userMail={{
          label: t(`${Namespace.glossary}:eMailAddress`),
          helpText: t(`${translationNamespace}:chooseUserHelpText`),
          patternMismatchErrorMessage: t(`${translationNamespace}:emailNotValid`),
        }}
        userSelect={{
          label: t(`${translationNamespace}:chooseUser`),
          helpText: t(`${translationNamespace}:chooseUserHelpText`),
          validationMessage: t(`${translationNamespace}:validationMessage`),
        }}
        roleSelect={{ label: t(`${translationNamespace}:roleName`) }}
        message={{ label: t(`${Namespace.glossary}:message`) }}
        submit={{ name: t(`${translationNamespace}:sendInvite`) }}
      />
    </Form>
  );
}

export const TeamroomInviteView = asFetchableView(TeamroomInvite);
